/**
 * Create a shallow copy of an object flattening nested
 * objects one level deep.
 */
export function flattenObj(obj) {
  return Object.fromEntries(
    Object.entries(obj)
      .reduce((a, [k, v]) => [
        ...a,
        ...(typeof v === 'object' && v !== null
          ? Object.entries(v)
          : [[k, v]])
      ], [])
  );
}

/**
 * Create a shallow copy of an object including only the properties
 * specified by "keys".
 */
export function pick(obj, keys) {
  return Object.fromEntries(
    Object.entries(obj).filter(([k]) => keys.includes(k))
  );
}

/**
 * Check whether an object contains properties with the specified keys.
 * @param {Object} obj The object to test.
 * @param {Array} props An array of prop keys to check for.
 * @returns True if obj contains all of the specified prop keys.
 */
export function hasProps(obj, props) {
  const keys = Object.keys(obj || {});
  return Array.from(props || []).every(p => keys.includes(p));
}
